import { type RouteRecordRaw } from 'vue-router'

import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

export const billingRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/BillingPayoutsView.vue'),
        meta: {
          title: 'billing.payouts',
        },
        name: 'brand.billing.payouts',
        path: 'payouts',
      },
      {
        component: async () =>
          import('../../reports-v2/views/PayoutDetailPage.vue'),
        meta: {
          title: 'billing.payouts',
        },
        name: 'brand.billing.payouts.detail',
        path: 'payouts/:payoutId',
        props: true,
      },
      {
        component: async () => import('../views/BillingHomeView.vue'),
        meta: {
          title: 'billing.invoices',
        },
        name: 'brand.billing.invoices',
        path: 'invoices',
      },
      {
        component: async () => import('../views/BillingDetailView.vue'),
        meta: {
          title: 'billing.invoices',
        },
        name: 'brand.billing.invoices.detail',
        path: 'invoices/:invoiceId',
      },
      {
        component: async () => import('../views/BillingTransactionsView.vue'),
        meta: {
          title: 'billing.transactions',
        },
        name: 'brand.billing.transactions',
        path: 'transactions',
      },
      {
        component: async () => import('../views/TransactionDetailView.vue'),
        meta: {
          title: 'billing.transactions',
        },
        name: 'brand.billing.transactions.detail',
        path: 'transactions/:transactionId',
      },
      {
        component: async () => import('../views/BillingPaymentMethodView.vue'),
        meta: {
          title: 'billing.subscriptions',
        },
        name: 'brand.billing.methods',
        path: 'methods',
      },
      {
        component: async () => import('../views/BillingAccountView.vue'),
        meta: {
          title: 'billing.account',
        },
        name: 'brand.billing.account',
        path: 'account',
      },
      {
        component: async () => import('../views/BillingDisputesView.vue'),
        meta: {
          // Disputes renders the Stripe embedded component, which depends on
          // POST /stripe-account-session — gated on location:update server-side.
          // Gating the route hides the nav item and blocks direct navigation
          // for users who can't use that endpoint.
          authZ({ user }) {
            // TODO(tmahoney): rewrite the comment above once this flag is fully
            //  rolled out & being cleaned up.
            const checkNewDisputePermission = useReactiveFeatureFlag(
              'hermes.useNewPaymentsPermissionChecksForDisputes'
            ).enabled
            return checkNewDisputePermission.value
              ? user.can('read', 'dispute')
              : user.can('update', 'location')
          },
          title: 'billing.disputes',
        },
        name: 'brand.billing.disputes',
        path: 'disputes',
      },
    ],
    component: {
      name: 'BillingRouterView',
      template: '<router-view></router-view>',
    },
    meta: {
      authZ: ({ user }) => user.can('read', 'billing'),
    },
    name: 'brand.billing',
    path: 'billing',
    redirect: { name: 'brand.billing.payouts' },
  },
]
